import React, { useRef, useEffect } from "react";
import { useGlobalContext } from "../context";

const SearchBar = () => {
  const { setSearchtext } = useGlobalContext();
  const searchContainer = useRef("");
  function searchCocktail() {
    setSearchtext(searchContainer.current.value);
  }
  function handleSubmit(e) {
    e.preventDefault();
  }
  useEffect(() => {
    searchContainer.current.focus();
  }, []);
  return (
    <section className="section search">
      <form className="search-form" onSubmit={handleSubmit}>
        <div className="form-control">
          <label htmlFor="name">search your favorite cocktail</label>
          <input
            type="text"
            id="name"
            name="name"
            ref={searchContainer}
            onChange={searchCocktail}
          />
        </div>
      </form>
    </section>
  );
};

export default SearchBar;
